import React from 'react';

import StatusBox from 'components/StatusBox';
import {BOOKING_STATUSES} from 'ducks/bookings';

/*
 * Colors taken from stylesheet:
 * https://app.zeplin.io/project/5a704ec521542ab450a55180/screen/5b61b1db690b0fdc2ff33e94
 */

const BOOKING_STATUS_TO_COLOR = {
  [BOOKING_STATUSES.RESERVED]: '#ffbd5e',
  [BOOKING_STATUSES.QUALIFIED]: '#ff9420',
  [BOOKING_STATUSES.CONFIRMED]: '#49cd35',
  [BOOKING_STATUSES.DUE_IN]: '#00c6c0',
  [BOOKING_STATUSES.IN_HOUSE]: '#7fbce3',
  [BOOKING_STATUSES.NO_SHOW]: '#d277a4',
  [BOOKING_STATUSES.DUE_OUT]: '#dc8d8d',
  [BOOKING_STATUSES.CHECKED_OUT]: '#d8b4b4',
  [BOOKING_STATUSES.CANCELLED]: '#b5beca',
  [BOOKING_STATUSES.OVERSTAY]: '#ff4242'
};

const BookingStatus = ({status}) => {
  return <StatusBox status={status} color={BOOKING_STATUS_TO_COLOR[status]} />;
};

export default BookingStatus;
